import { useRouter } from "next/router"
import { useGroups } from "../useGroups";
import { useEffect } from "react";

interface IUseRestrictUserType {
  allowedUserTypeIds: number[];
};

export const useRestrictUserType = ({ allowedUserTypeIds }: IUseRestrictUserType) => {
  const { push } = useRouter();
  const { userType, isProjectAdmin, isLoading } = useGroups();

  useEffect(() => {
    if(isLoading) return;

    if(isProjectAdmin) return;

    if(allowedUserTypeIds.includes(Number(userType?.id))) {
      return;
    };

    push('/dashboard');

  }, [isLoading, userType, isProjectAdmin])

};